export enum ReleaseNoteTypes {
  IMPROVMENT = "IMPROVMENT" as any,
  BUGFIX = "BUGFIX" as any,
  NEWFEATURE = "NEWFEATURE" as any,
  DESIGNUPDATE = "DESIGNUPDATE" as any,
  SIMPLIFICATION = "SIMPLIFICATION" as any,
}
